import { georgeIdMigrationTour as AT } from './AT';
import { georgeIdMigrationTour as CZ } from './CZ';
import { georgeIdMigrationTour as HR } from './HR';
import { georgeIdMigrationTour as HU } from './HU';
import { georgeIdMigrationTour as RO } from './RO';
import { georgeIdMigrationTour as SK } from './SK';
import { georgeIdMigrationTour as RS } from './RS';

export const featureMap = {
    AT,
    CZ,
    HR,
    HU,
    RO,
    SK,
    RS,
};
